/* eslint-disable no-restricted-globals */

import { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Control, Errors, Form } from 'forms/rrf';
import { toast } from 'react-toastify';
import { Button, Col, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap';
import BsCheckbox from '../../../common/form/elements/bs-checkbox';
import BsRadio from '../../../common/form/elements/bs-radio';
import { validators } from '../../../../utils/validators';
import ErrorMessages from '../../login/error-messages';
import ConfirmPopup from '../../../common/confirm-popup';
import UserTitleSelector from '../../../common/form/user/user-title-selector';
import UserFirstNameInput from '../../../common/form/user/user-first-name-input';
import UserLastNameInput from '../../../common/form/user/user-last-name-input';
import ArrowButton from '../../../common/button-arrow';
import { history } from '../../../../store';
import { deleteAdmin, getUserBaseData, saveAdmin, sendWelcomeEmail, updateAdmin } from '../../../../actions/users';
import { GROUP_ABM, GROUP_RBM, GROUP_RDR } from '../../../../data/userGroups';
import ToastMessage from '../../../common/toast-message';
import TextInput from '../../../common/form/elements/text-input';
import RequiredInput from '../../../common/form/elements/required-input';
import AbmSelector from '../../../common/form/user/abm-selector';
import DateOfBirthSelector from '../../../common/form/user/date-of-birth-selector';

const createConfirmationMessage = save => (save ? (
  <p>
    You have created a new user - do
    you want to generate the welcome email?
  </p>
) : (
  <p>
    Do you want to generate the welcome email?
  </p>
));

class EditUserForm extends Component {
  state = {
    showWelcomePopup: false,
    showDeletePopup: false
  };

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  toggleWelcomePopup = () => {
    this.setState({
      showWelcomePopup: !this.state.showWelcomePopup
    });
  };

  handleWelcomePopup = (result) => {
    const { dispatch, user, showWelcomePopupSave } = this.props;

    if (result) {
      dispatch(sendWelcomeEmail(user.id));
    }

    if (showWelcomePopupSave) {
      dispatch({type: 'WELCOME_EMAIL_SENT'});
      dispatch({type: 'CLEAR_EDIT_USER'});
      history.push('/admin/users');
    }

    this.toggleWelcomePopup();
  };

  toggleDeletePopup = () => {
    this.setState({
      showDeletePopup: !this.state.showDeletePopup
    });
  };

  handleDeletePopup = (result) => {
    const {dispatch, user} = this.props;

    if (result) {
      dispatch(deleteAdmin(user.id))
        .then(history.push('/admin/users'));
    }

    this.toggleDeletePopup();
  };

  onSubmit = (payLoad) => {
    const { dispatch, user } = this.props;

    if (this.isRepUserGroupSelected() && this.isEmployeeCodeEmpty()) {
      toast.error(<ToastMessage iconStyle="error" message="Employee code is required for rep users."/>);
      return false;
    }

    if (user.id) {
      dispatch(actions.submitFields('deep.admin_user.edit', updateAdmin(this.props.user.id, payLoad)))
        .then(() => {
          dispatch(actions.reset('deep.admin_user.edit'));
          history.push('/admin/users');
        });
    } else {
      dispatch(actions.submitFields('deep.admin_user.edit', saveAdmin(payLoad)))
        .then(() => {
          dispatch(actions.reset('deep.admin_user.edit'));
        });
    }

    return true;
  };

  isEmployeeCodeEmpty = () => !(this.props.employeeCode && this.props.employeeCode.length);

  showFormExtension = () => this.isRepUserGroupSelected();

  UNSAFE_componentWillMount() {
    if (!this.props.id) {
      this.props.dispatch(getUserBaseData());
    }
  }

  isRepUserGroupSelected() {
    const userGroupsExtended = [GROUP_RBM, GROUP_RDR, GROUP_ABM];
    const { userGroups, userGroupId } = this.props;

    if (userGroups === undefined) {
      return false;
    }

    const userGroup = userGroups.find(group => group.id === parseInt(userGroupId));

    if (userGroup === undefined) {
      return false;
    }

    return userGroupsExtended.includes(userGroup.name.toLowerCase());
  }

  isAbmUserGroup = () => {
    const { userGroups, userGroupId } = this.props;

    if (userGroups === undefined) {
      return false;
    }

    const userGroup = userGroups.find(group => group.id === parseInt(userGroupId));

    if (userGroup === undefined) {
      return false;
    }

    return GROUP_ABM === userGroup.name.toLowerCase();
  }

  render() {
    const {
      userGroups, showWelcomePopupSave, commsEmail, statuses, id, showDeletePopup, formValid
    } = this.props;
    const { user_group: userGroup, user_status: userStatus, showWelcomePopup } = this.state;

    return (
      <Form
        className="user-edit-form"
        model="deep.admin_user.edit"
        onSubmit={this.onSubmit}
        validateOn="submit"
      >
        <Errors className="errors" component={ErrorMessages} model="deep.admin_user.edit"/>
        <Row>
          <Col lg={6}>
            <UserTitleSelector model="deep.admin_user.edit.title"/>

            <UserFirstNameInput/>

            <UserLastNameInput/>

            {this.isRepUserGroupSelected() && <DateOfBirthSelector />}

            <FormGroup controlId="userGroup" validationState={userGroup}>
              <FormLabel>
                Usergroup*
              </FormLabel>
              <Control.select
                component={FormControl}
                as="select"
                model=".user_group_id"
                validators={{required: validators.required(this.updateErrors, 'user_group')}}
              >
                <option value="" disabled>
                  Select group...
                </option>
                {
                  userGroups && userGroups.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))
                }
              </Control.select>

              <Errors
                className="errors"
                messages={{required: 'This field is required'}}
                model=".user_group_id"
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>
          </Col>

          <Col lg={6}>
            <FormLabel>
              {/**/}
              Communication preferences*
            </FormLabel>
            <br/>
            <Col lg={3}>
              <FormGroup>
                <Control.checkbox model=".comms_email" disabled component={BsCheckbox}>
                  email
                </Control.checkbox>
              </FormGroup>
            </Col>
            <Col lg={9}>
              <FormGroup>
                <Control.text
                  component={FormControl}
                  disabled={!commsEmail}
                  model=".email"
                  placeholder="Email"
                  type="email"
                />

                <Errors
                  className="errors"
                  model=".email"
                  show={{
                    touched: true,
                    focus: false
                  }}
                />
              </FormGroup>
            </Col>

            <FormGroup controlId="userStatus" validationState={userStatus}>
              <FormLabel>
                Status*
              </FormLabel>
              <Control.select
                component={FormControl}
                as="select"
                model=".status"
                validators={{required: validators.required(this.updateErrors, 'user_status')}}
              >
                <option value="" disabled>
                  Select status...
                </option>
                {
                  statuses && Object.keys(statuses)
                    .map(item => (
                      <option key={item} value={item}>
                        {statuses[item]}
                      </option>
                    ))
                }
              </Control.select>

              <Errors
                className="errors"
                messages={{required: 'This field is required'}}
                model=".status"
                show={{
                  touched: true,
                  focus: false
                }}
              />
            </FormGroup>

            <FormGroup controlId="userAccountLocked">
              <div>
                <FormLabel>
                  Account locked*
                </FormLabel>
              </div>
              <Control.radio
                component={BsRadio}
                model=".account_locked"
                validators={{required: validators.required(this.updateErrors, 'account_locked')}}
                value="true"
              >
                Yes
              </Control.radio>
              <Control.radio
                component={BsRadio}
                model=".account_locked"
                validators={{required: validators.required(this.updateErrors, 'account_locked')}}
                value="false"
              >
                No
              </Control.radio>

              <Errors
                className="errors"
                messages={{required: 'You must set account lock state.'}}
                model=".account_locked"
                show={{touched: true}}
              />
            </FormGroup>
          </Col>
        </Row>
        {this.isAbmUserGroup() && !!id && <AbmSelector />}
        {this.showFormExtension() && (
          <Row>
            <Col lg={12}>
              <RequiredInput label="Employee code" model=".employee_code" placeholder="Employee code"/>
            </Col>
            <Col lg={6}>
              <TextInput label="RDR code" model=".rdr_code"/>
              <TextInput label="ABM code" model=".abm_code"/>
              <TextInput label="RBM code" model=".rbm_code"/>
            </Col>
            <Col lg={6}>
              <TextInput label="FFDE code" model=".ffde_code"/>
              <TextInput label="ROR code" model=".ror_code"/>
              <TextInput label="AM code" model=".am_code"/>
            </Col>
          </Row>
        )}
        <Row>
          <Col md={6}>
            {!isNaN(id) && (
              <Button
                block
                onClick={this.toggleWelcomePopup}
                className="red-ghost-btn"
              >
                Generate welcome notification
              </Button>
            )}
            {(showWelcomePopup || showWelcomePopupSave) && (
              <ConfirmPopup
                cancelLabel={showWelcomePopupSave ? 'No' : 'Cancel'}
                confirmLabel={showWelcomePopupSave ? 'Yes' : 'Confirm'}
                header="Send welcome email?"
                onClose={this.handleWelcomePopup}
              >
                {createConfirmationMessage(showWelcomePopupSave)}
              </ConfirmPopup>
            )}
          </Col>
          <Col md={6}>
            <ArrowButton className="float-end" disabled={!formValid}>
              Save
            </ArrowButton>

            {!isNaN(id) && (
              <ArrowButton
                arrow={false}
                className="float-end"
                color="grey"
                onClick={this.toggleDeletePopup}
                permissions={{
                  action: 'destroy',
                  subjectClass: 'User'
                }}
                submit={false}
              >
                Delete user
              </ArrowButton>
            )}

            {showDeletePopup && (
              <ConfirmPopup header="Delete user?" onClose={this.handleDeletePopup}>
                <p>
                  Do you really want to delete this user?
                  This operation will redact all personal information on the user record?
                </p>
              </ConfirmPopup>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  user: state.users.user,
  statuses: state.users.editorInput.statuses,
  userGroups: state.users.editorInput['user-groups'],
  userGroupId: state.deep.admin_user.edit.user_group_id,
  employeeCode: state.deep.admin_user.edit.employee_code,
  commsEmail: state.deep.admin_user.edit.comms_email,
  formValid: state.deep.forms.admin_user.edit.$form.valid,
  showWelcomePopupSave: state.users.showWelcomePopup
});

export default connect(mapStateToProps)(EditUserForm);
